export default {
    created: "Contactul WhatsApp a fost creat cu succes.",
    updated: "Contactul WhatsApp a fost actualizat cu succes.",
    deleted: "Contactul WhatsApp a fost sters cu succes.",
    restored: "Contactul WhatsApp a fost restaurat cu succes.",
}
